"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var each_1 = require("@antv/util/lib/each");
var is_array_1 = require("@antv/util/lib/is-array");
var is_string_1 = require("@antv/util/lib/is-string");
var regexTags = /[MLHVQTCSAZ]([^MLHVQTCSAZ]*)/ig;
var regexDot = /[^\s\,]+/ig;
function parsePath(p) {
    var path = p || [];
    if (is_array_1.default(path)) {
        return path;
    }
    if (is_string_1.default(path)) {
        path = path.match(regexTags);
        each_1.default(path, function (item, index) {
            // @ts-ignore
            item = item.match(regexDot);
            if (item[0].length > 1) {
                var tag = item[0].charAt(0);
                // @ts-ignore
                item.splice(1, 0, item[0].substr(1));
                // @ts-ignore
                item[0] = tag;
            }
            // @ts-ignore
            each_1.default(item, function (sub, i) {
                if (!isNaN(sub)) {
                    // @ts-ignore
                    item[i] = +sub;
                }
            });
            // @ts-ignore
            path[index] = item;
        });
        return path;
    }
}
exports.default = parsePath;
//# sourceMappingURL=parse-path.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/path-util/lib/parse-path.js
// module id = 1065
// module chunks = 37